function toDateInputValue(value) {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toISOString().slice(0, 10);
}

export function mapMilestoneApiToDialog(milestone = {}) {
  return {
    title: milestone.title || '',
    dueDate: toDateInputValue(milestone.dueDate),
    actualDate: toDateInputValue(milestone.actualDate),
    responsibleUserId: milestone.responsibleUserId || '',
    constraintIds: Array.isArray(milestone.constraintIds) ? [...milestone.constraintIds] : [],
  };
}

export function mapMilestoneDialogToApiPayload(form) {
  const payload = {
    title: String(form.title || '').trim(),
    dueDate: new Date(form.dueDate).toISOString(),
  };

  if (form.actualDate) {
    payload.actualDate = new Date(form.actualDate).toISOString();
  }

  if (form.responsibleUserId) {
    payload.responsibleUserId = form.responsibleUserId;
  } else {
    payload.responsibleUserId = null;
  }

  payload.constraintIds = Array.isArray(form.constraintIds) ? form.constraintIds : [];

  return payload;
}

export function validateMilestoneDialogForm(form, t) {
  const errors = {};
  if (!String(form.title || '').trim()) {
    errors.title = t('UserProjects.milestoneDialog.validation.nameRequired');
  }
  if (!String(form.dueDate || '').trim()) {
    errors.dueDate = t('UserProjects.milestoneDialog.validation.targetDateRequired');
  }
  return errors;
}

export function emptyMilestoneDialogForm() {
  return {
    title: '',
    dueDate: '',
    actualDate: '',
    responsibleUserId: '',
    constraintIds: [],
  };
}
